<template>
  <div class="modal-mask">
    <section class="modal">
      <div class="content">
        <!-- HEAD Modify profile -->
        <h1>{{$t('modifyProfil.title')}} {{profile.name}}</h1>
      </div>
      <hr>
      <div class="content">
        <div class="column">
          <label>{{$t('modifyProfil.name')}}</label>
          <div class="row">
            <input
              type="text"
              v-model="profile['name']"
            />
            <p class="tips">{{$t('modifyProfil.nameTips')}}</p>
          </div>
        </div>
        <div class="column">
          <label>{{$t('modifyProfil.description')}}</label>
          <div class="row">
            <input
              type="text"
              v-model="profile['description']"
            />
            <p class="tips">{{$t('modifyProfil.descriptionTips')}}</p>
          </div>
        </div>
        <!-- default profile -->
        <label class="container">
          <input
            type="checkbox"
            v-model="profile['default-profile']"
          />
          <span class="checkmark"></span>{{$t('newProfile.defaultProfile')}}
        </label>
      </div>
      <hr>
      <div class="content">
        <div class="row">
          <div class="column">
            <div v-for="info in checkboxInfoList1" :key="info.title" class="row">
              <label class="container">
                <input
                  type="checkbox"
                  v-model="profile[info.model]"
                />
                <span class="checkmark"></span><p style="padding-right: 25px;">{{info.value}}</p>
              </label>
              <br><br>
            </div>
          </div>
           <div class="column">
            <div v-for="info in checkboxInfoList2" :key="info.title" class="row">
              <label class="container">
                <input
                  type="checkbox"
                  v-model="profile[info.model]"
                />
                <span class="checkmark"></span>{{info.value}}
              </label>
              <br><br>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <button @click="update">{{$t('button.modifyProfile')}}</button>
        <a @click="$emit('close')">{{$t('button.cancel')}}</a>
      </div>
    </section>
  </div>
</template>

<script>
import Profiles from "@/services/Profiles.js";
export default {
  props: ["profile"],
  data() {
    return {
      checkboxInfoList1: [
        {
          model: "user-administration",
          value: (this.$t('newProfile.manageUsers'))
        },
        {
          model: "all-campaigns-access",
          value: this.$t("newProfile.accessAllCampaign")
        },
        {
          model: "coupon-retrieval",
          value: this.$t("newProfile.assignCoupons")
        },
        {
          model: "coupon-export",
          value: this.$t("newProfile.exportCoupons")
        },
        {
          model: "campaign-follow-up",
          value: this.$t("newProfile.recapCampaign")
        }],
     checkboxInfoList2: [
        {
          model: "campaign-administration",
          value: this.$t("newProfile.manageCampaign")
        },
        {
          model: "sales-channel-administration",
          value: this.$t("newProfile.manageSalesChannels")
        },
        {
          model: "product-administration",
          value: this.$t("newProfile.manageProducts")
        },
        { model: "user-invitation", value: this.$t("newProfile.inviteUser") },
        {
          model: "user-profile-administration",
          value: this.$t("newProfile.manageProfiles")
        }
      ]
    };
  },
  mounted() {
  },
  methods: {
    update() {
      Profiles.partialUpdate(this.profile.id, this.profile).then(res => {
        if (res.status == 204) {
          this.$emit("profilechanged");
        }
      });
    }
  }
};
</script>